import { useCallback, useRef } from 'react';
import ReactPlayer from 'react-player';

import classNames from 'classnames/bind';
import { MediaGallery, Typography } from 'shared';
import Box from 'shared_DEPRECATED/components/Box/Box';
import { Video } from 'shared_DEPRECATED/components/Video/Video';
import { Attachments } from 'shared_DEPRECATED/types/Attachment';
import { ProcessingStatus } from 'types/common';

import { getMediaAttachmentStyles } from 'features/chat/utils';

import { modal, SIZES } from 'shared/components/Modal';
import { ProcessingStatuses } from 'shared/config';

import { ChatMessageVideoModal } from './ChatMessageVideoModal';
import { VideoProcessingOrLoading } from './VideoProcessingOrLoading';
import styles from 'features/chat/components/Chat.module.css';

type ChatMessageVideoAttachmentProps = {
  url: string;
  attachmentKey?: string;
  isLastAttachment: boolean;
  index: number;
  processingStatus: ProcessingStatus | null;
  media: Attachments;
  previewSrc: string;
};

const cx = classNames.bind(styles);

export const ChatMessageVideoAttachment = ({
  url,
  attachmentKey,
  isLastAttachment,
  index,
  processingStatus,
  media,
  previewSrc,
}: ChatMessageVideoAttachmentProps) => {
  const videoRef = useRef<ReactPlayer>(null);
  const { borderRadius, flexBasis, aspectRatio } = getMediaAttachmentStyles(
    index,
    isLastAttachment
  );

  const handleVideoClick = useCallback(
    () =>
      modal.open({
        content:
          media.length > 1 ? (
            <MediaGallery media={media as any[]} selectedMediaIndex={index} />
          ) : (
            <ChatMessageVideoModal src={media[0].url} />
          ),
        props: {
          title: '',
          size: SIZES.SM,
        },
      }),
    [media, index]
  );

  return (
    <Box
      style={{
        flexBasis,
        aspectRatio,
        position: 'relative',
      }}
    >
      {!attachmentKey && (
        <VideoProcessingOrLoading borderRadius={borderRadius} />
      )}
      {attachmentKey &&
        processingStatus &&
        processingStatus !== ProcessingStatuses.COMPLETE && (
          <VideoProcessingOrLoading borderRadius={borderRadius}>
            <Typography type="meta" color="white">
              Just a moment!
            </Typography>
            <Typography type="meta" color="white">
              Processing your video.
            </Typography>
          </VideoProcessingOrLoading>
        )}
      <Video
        ref={videoRef}
        light={previewSrc}
        onClickPreview={() => {
          videoRef.current?.showPreview();
          handleVideoClick();
        }}
        width="350px"
        src={url}
        className={cx('media-preview')}
        data-testid="chat-video-preview"
        height="320"
      />
    </Box>
  );
};
